var map = {
	"./arobot.ts": "28f6",
	"./disinfect.ts": "1fcc",
	"./errorPage.ts": "6745",
	"./region.ts": "b395",
	"./subscriber.ts": "daea",
	"./system.ts": "2589"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a824";